export enum ButtonVariant {
	Primary = "primary",
	Secondary = "secondary",
	Tertiary = "tertiary",
	Quaternary = "quaternary",
	Quinary = "quinary",
}

export const controlSizeStyle = {
	m: "min-height: 29px;",
	sm: `font-size: 11px;
		padding: 2px 10px;
		min-height: 24px;`,
	xsm: `font-size: 10px;
		padding: 0px 4px;
		min-height: 20px;`,
};

export const variantStyle = {
	[ButtonVariant.Primary]: `background-color: #1f1f1f;
	color: #ffffff;

	&:not(:disabled):hover {
		background-color: #ec6728;
		border: 1px solid #414141;
	}

	&:not(:disabled):active {
		border: 1px solid #ec6728;
	}`,
	[ButtonVariant.Secondary]: `background-color: #ec6728;
	color: #ffffff;

	&:not(:disabled):hover {
		background-color: #d24e0f;
		border: 1px solid #db5e24;
	}

	&:not(:disabled):active {
		background-color: #b93400;
		border: 1px solid #ec6728;
	}`,
	[ButtonVariant.Tertiary]: `background-color: #ffffff;
	color: #1f1f1f;


	&:not(:disabled):active {
		background-color: #ffffff;
	}`,
	[ButtonVariant.Quaternary]: `background-color: #ffffff;
	border: 1px solid #575757;
	color: #1f1f1f;

	&:not(:disabled):hover {
		border: 1px solid #ec6728;
	}

	&:not(:disabled):active {
		background-color: #ffffff;
	}`,
	[ButtonVariant.Quinary]: `background-color: transparent;
	border: 1px solid transparent;
	color: #1f1f1f;

	&:not(:disabled):hover {
		color: #ec6728;
	}

	&:not(:disabled):active {
		color: #1f1f1f;
		font-weight: bold;
	}
	}`,
};
